// extracted by mini-css-extract-plugin
module.exports = {"loading-wrap":"loading_loading-wrap__nnulA","loadingWrap":"loading_loading-wrap__nnulA"};